import React from 'react'
import DynamicLink from '../atoms/DynamicLink'

const AdvantageDisadvantageCard = ({ heading, rows, footerText, button }) => (
  <div className="bg-white shadow-box rounded-[5px] overflow-hidden">
    <div className="px-6 py-3 font-bold text-white bg-black u-p">{heading}</div>
    <div className="px-6 space-y-6 py-7">
      <ul className="space-y-2">
        {rows.map(row => (
          <li key={row.text} className={`text-[15px] flex`}>
            <div className={row.isDisabled ? 'w-6.5' : ''}>
              {!row.isDisabled && !row.isInfo && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  fill="none"
                  viewBox="0 0 22 22"
                  className="mr-1"
                >
                  <path
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 10.963L9.357 14.5 16 7.5"
                  ></path>
                </svg>
              )}
              {row.isInfo && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  fill="none"
                  viewBox="0 0 22 22"
                  className="mr-1"
                >
                  <path
                    fill="#000"
                    d="M19.315 14.444a9 9 0 10-16.63-6.888 9 9 0 0016.63 6.888z"
                  ></path>
                  <path
                    fill="#fff"
                    d="M9.798 9.633h2.74L11.742 16H9l.798-6.367zM11.455 6c.448 0 .818.123 1.109.37.29.238.436.566.436.985 0 .23-.041.43-.125.603a1.242 1.242 0 01-.336.431 1.433 1.433 0 01-.498.259 2.022 2.022 0 01-1.171 0 1.597 1.597 0 01-.5-.259 1.242 1.242 0 01-.336-.43 1.375 1.375 0 01-.124-.604c0-.419.145-.747.436-.986.299-.246.668-.369 1.109-.369z"
                  ></path>
                </svg>
              )}
            </div>
            <div className={`${row.isDisabled && 'text-gray-5'}`}>
              {row.text}
            </div>
          </li>
        ))}
      </ul>

      {footerText && <div className="text-[13px]">{footerText}</div>}

      {button.text && (
        <div>
          <DynamicLink link={button} className="u-btn" />
        </div>
      )}
    </div>
  </div>
)

export default AdvantageDisadvantageCard
